// Single source of truth for the editorial "atlas" design language.
//
// These mirror theme values so they can be used in raw contexts where Chakra
// tokens don't resolve — inline style props, SVG fill/stroke attributes, etc.
// Prefer the Chakra equivalents in JSX where possible:
//   ACCENT  -> color="gwbi.600"
//   SERIF   -> fontFamily="heading" (or just <Heading>)
//   PAPER   -> bg="surface.canvas"
//   RAIL    -> bg="surface.rail"

export const ACCENT = "#7A2E2E"; // bordeaux — theme color gwbi.600
export const ACCENT_HOVER = "#5e2222"; // darker bordeaux for button :hover
export const SERIF = "Georgia, 'Times New Roman', serif"; // theme fonts.heading
export const PAPER = "#fbfaf8"; // warm paper canvas — surface.canvas
export const RAIL = "#f3eee6"; // warm sidebar/rail fill — surface.rail
